<template>
    <div>
        <div class="row">
            <div class="col">
                <input type="text" class="form-control col" placeholder="Ketik Merk Mobil" v-model="search">
                <!-- <input type="text" class="form-control" placeholder="Ketik Merk Mobil" v-model="search" @keyup.enter="searchProduct()"> -->
            </div>

            <!-- <button type="submit" class="btn btn-primary" style="width: 25%; margin-left: 5%;" @click="searchProduct()">Search</button> -->
        </div>
        <div class="productList" style="margin-top: 2.5vh; overflow: auto; border: 1px solid #9E9E9E; border-radius: 5px;" :class="[{'desktopHeight' : !mobile}, {'mobileHeight' : mobile}]">
            <div style="border-top: 1px solid #E0E0E0; min-height: 5vh; width: 100%;" class="product" v-for="product in filteredData" @click="$emit('detail-of', product.id)">
                <div style="padding:10px">
                    <h3>{{product.name}}</h3>
                </div>
                <!-- <div style="text-align: right; padding:0 10px 10px 10px; width: 95%;">
                    QR: {{product.qr}}
                </div> -->
            </div>

            <div
            v-if="!config.maxReached"
            style="border: 1px solid #E0E0E0; min-height: 5vh;  width: 100%; display: flex; align-items: center; justify-content: center;"
            v-observe-visibility="visibilityChanged">
                <!-- Fetching Data... -->
                <img src="/img0/loading.gif" width="20px" height="20px">
            </div>
            <div v-else style="border-top: 1px solid #E0E0E0;  width: 100%;"></div>
        </div>
    </div>
</template>

<script>
    import { ObserveVisibility } from "vue-observe-visibility";
    
    export default{
        data(){
            return{
                bottom: false,
                search : '',
                data : [],
                config : {
                    limit : 1000,
                    page : 1,
                    maxReached : false,
                    isVisible : false,
                    isFetching : false,
                },
            }
        },
        directives: {
            ObserveVisibility
        },
        props:['company', 'mobile', 'tooltipMessage'],
        mounted(){
            this.fetchData()
        },
        computed : {
            filteredData () {
                var compiledData = []
                if(this.search != '' && this.search != null){
                    for(var i in this.data){
                        if(this.data[i].name.toLowerCase().includes(this.search.toLowerCase())) compiledData.push(this.data[i])
                    }
                } else {
                    compiledData = this.data
                }
                return compiledData;
            },
        },
        methods:{
            fetchData(){
                if (this.config.maxReached) return;

                this.config.isFetching = true;
                var vm = this;

                var url = `/api/v1/masterData/car/brand?limit=${this.config.limit}&page=${this.config.page}&order=ASC&by=name`;

                // if(this.search != '' && this.search != null){
                //     url = `${url}&search=${this.search}`;
                // }

                this.$http.get(url)
                .then((resp)=>{

                    var data = resp.data.data;

                    vm.config.page++;//prepares for next page

                    if (data.length < vm.config.limit || data.length == 0) vm.config.maxReached = true
                    vm.data = vm.data.concat(data)
                })
                .catch((err)=>{
                    console.log(err);
                })
                .finally(()=>{
                    vm.config.isFetching = false;
                })
            },
            visibilityChanged (isVisible, entry) {
                this.config.isVisible = isVisible
                // console.log(entry)

                if(this.config.isVisible && !this.config.maxReached && !this.config.isFetching) this.fetchData();
            },
            searchProduct(){
                //RESET DATA
                this.data.length = 0;
                this.config.page = 1;
                this.config.maxReached = 0;

                this.fetchData();
            }
        }
    }
</script>

<style scoped>
    .desktopHeight{
        height: 70vh
    }
    .mobileHeight{
        height: 60vh;
    }
    .product:hover{
        cursor: pointer;
        background-color: #F5F5F5;
    }

    .productList::-webkit-scrollbar{
        width:10px;
    }
    .productList::-webkit-scrollbar-track{
        background-color:#E0E0E0;
        border-radius: 20px;
    }
    .productList::-webkit-scrollbar-thumb{
        background-color:#2D353C;
        border-radius: 20px;
    }
</style>